import { render, staticRenderFns } from "./TopNav.vue?vue&type=template&id=5e4fab8c&scoped=true&"
import script from "./TopNav.vue?vue&type=script&lang=js&"
export * from "./TopNav.vue?vue&type=script&lang=js&"
import style0 from "./TopNav.vue?vue&type=style&index=0&id=5e4fab8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4fab8c",
  null
  
)

export default component.exports